var _path, _path2, _path3, _line, _line2, _line3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7979 39.625H3.33081L2.12891 45.1194H46.9998L45.7979 39.625Z",
    fill: "#E7EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 29.6667C29.5159 30 32.6905 31 35.7381 31C38.7857 31 41.5794 29.8889 42.9762 29C43.5857 28.7333 44.373 28 44.5 28",
    stroke: "#FF8165",
    strokeWidth: 1.93,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.964 12.474C36.9699 13.2763 38.9758 12.474 38.9758 12.474M38.9758 12.474C38.9758 12.474 42.1853 11.6716 42.1853 9.26453C42.1853 6.0551 40.5805 4.85156 35.3652 4.85156C30.5511 4.85156 28.144 6.21227 28.144 9.26453C28.144 11.5111 30.2836 12.6077 31.3534 12.8751V20.0963C31.3534 22.1022 28.5938 23.4233 27.7428 23.707C26.5393 24.1081 24.9346 25.3117 24.9346 26.9164C24.9346 28.2002 24.9346 30.9282 24.9346 32.1317C25.3357 33.6027 27.9033 36.5447 34.964 36.5447C42.0248 36.5447 44.5923 33.6027 44.9935 32.1317V26.9164C44.9935 25.9803 44.9935 24.5093 43.3888 23.707C41.4565 22.7408 38.5746 22.1022 38.5746 20.4975C38.5746 19.2138 38.8555 14.7473 38.9758 12.474Z",
    stroke: "#081E54",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.9647,
    y1: 17.1974,
    x2: 24.8691,
    y2: 17.1974,
    stroke: "#1552E8",
    strokeWidth: 0.933333,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.162,
    y1: 20.4083,
    x2: 24.0664,
    y2: 20.4083,
    stroke: "#1552E8",
    strokeWidth: 0.933333,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.3602,
    y1: 23.6271,
    x2: 19.2528,
    y2: 23.6271,
    stroke: "#1552E8",
    strokeWidth: 0.933333,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7959 40.1262L46.9994 44.9404H2.06738L10.091 13.6484H25.3357",
    stroke: "#081E54",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.012fc1cc68773f96a271b342406a6c94.svg";
export { ForwardRef as ReactComponent };